import styled from "styled-components";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";

function Refund(){
    return(
        <Container>
            <Header />
            <Content>
                <h2>환불 규정</h2>
                <Description>
                    취소 및 환불 규정<br/><br/>
                    * 제 1 조 [관계 법령상 환불 정책]<br/>
                    1. 회사의 본 약관상 환불규정 등은 “온라인 디지털콘텐츠산업 발전법”, “전자상거래 등에서의 소비자보호에 관한 법률” 등을 준수합니다.<br/>
                    2. 전 항의 관계법령에 따른 소비자의 청약철회가 불가능한 경우는 다음과 같습니다.<br/>
                    – 「문화산업진흥 기본법」 제2조 제5호의 디지털콘텐츠의 제공이 개시된 경우.<br/>
                    3. 「문화산업진흥 기본법」 제2조 제5호에 따라 두번째 월급 에서 제공하는 영상들은 디지털콘텐츠에 해당합니다.<br/><br/>
                    * 제 2 조 [유료 서비스 환불 규정]<br/>
                    1. “회사”는 서비스 대금의 환불에 관하여 다음과 같은 환불규정을 적용합니다.<br/>
                    b. 회원이 본인의 의사로 서비스 이용을 포기한 경우 서비스 시작 전에 한하여 납부한 서비스 대금의 전액을 환불합니다.<br/>
                    c. 서비스 시작 후 개인적인 이유로 서비스 이용을 포기한 경우<br/>
                    – 수강권은 평생교육법 환불 규정에 따라 아래와 같이 환불이 가능합니다.<br/>
                    – 아래 환불 규정에 적용되는 수강기간이란 전체 유료수강일수 중 경과한 수강일 또는 전체 강좌수 중 기수강한 강좌수 중 비중이 높은 부분을 의미합니다.<br/>
                    ◦ 반환 사유 발생일 수강시작 및 전자책 다운로드 전 : 이미 낸 학습비 전액 반환<br/>
                    ◦ 반환 사유 발생일 총 수강기간의 1/3 경과 전 : 이미 낸 학습비의 2/3에 해당하는 금액에서 이용료를 공제하고 반환<br/>
                    ◦ 반환 사유 발생일 총 수강기간의 1/2 경과 전 : 이미 낸 학습비의 1/2에 해당하는 금액에서 이용료를 공제하고 반환<br/>
                    ◦ 반환 사유 발생일 총 수강기간의 1/2 경과 후 : 반환하지 않음<br/>
                    – 모든 강의는 강의의 길이에 관계없이 1개의 강의로 취급합니다.<br/>
                    – 강의 재생 시간에 관계없이 강의를 클릭하거나 수업 노트를 열람한 경우도 수강한 것으로 간주합니다.<br/>
                    – 수강권의 수강기간은 일시정지 할 수 없습니다.<br/>
                    – 수업 자료를 열람 혹은 다운로드한 경우 해당 강의에 대해 전체 수강한 것으로 간주합니다.<br/>
                    – 이외 학습을 진행한 상황이 확인되면 환불이 불가능합니다.<br/>
                    2. 수강권에 클래스 강사의 피드백(코칭권)이 결합된 서비스의 경우 제 1항에서 산정한 각 반환금액에서 정가 기준 이용한 강사 피드백(코칭권)에 해당하는 금액을 제외한 금액을 반환합니다. 수강권에 강사 피드백(코칭권) 이외에 타 서비스가 결합된 서비스의 경우 별도의 환불기준이 적용될 수 있으며 “회사”는 이 경우 웹사이트에 관련사항을 고지합니다.<br/>
                    3. 기간이 지정된 유료 서비스의 제공 기간이 만료되었을 경우에는 환불이 이루어지지 않습니다.<br/>
                    4. 소모성, 일회성 유료 서비스는 환불이 되지 않습니다.<br/>
                    5. “회원”이 할인에 의해 서비스 대금을 결제하였을 경우, 서비스 대금 반환금액의 기준은 할인이 적용되어 실제 결제한 금액에 의하여 정합니다.<br/>
                    6. 환불은 신용카드 결제, 휴대폰 결제, 계좌이체 등 “회원”이 결제한 수단과 동일한 방식으로 함을 원칙으로 합니다. 단, 기술적으로 불가능한 경우에는 “회사”는 “회원”에게 합리적인 환불방법을 정하여 통지할 수 있습니다. “회원”이 해당 방법에 협조하지 않아 발생하는 환불의 지연 등에 관한 모든 불이익의 책임은 “회원”에게 있습니다.<br/>
                    7. “회원”은 다음 각 호에 나와있는 방법을 통해 “회사”에 환불 의사를 표시하여야 하며, “회사”는 환불 요청을 접수하고 “회원”의 요청과 환불 규정 확인 후 5일 이내에 환불 과정을 진행합니다. 다만 결제대행사, 카드사 등에서의 결제 취소 시간 및 금융사의 전산마비 등 “회사”의 책임영역 외의 사유로 인한 환불 지연에 대해서는 “회사”가 책임지지 않습니다.<br/>
                    a. “회원”은 서비스를 카드로 결제한 경우, 환불 요청시에는 문의하기로 환불 요청 의사를 표시하고 환불 절차에 필요한 정보를 전송해야 합니다.<br/>
                    b. “회원”은 서비스를 계좌이체를 통해 결제한 경우 문의하기로 환불 요청의사를 표시하고 환불 절차에 필요한 정보를 전송해야 합니다.<br/>
                    8. 이벤트성, 특별기획 서비스 등의 경우 별도의 수강 취소, 변경 및 환불규정이 적용될 수 있습니다. “회사”는 이 경우 웹사이트에 관련사항을 고지합니다.<br/>
                    9. 회원정보(이메일 주소, 실명 등)가 부정확하여 발생하는 환불의 지연 등의 책임은 “회원”에게 있습니다.<br/>
                    10. “회사”의 환불 예외사항은 다음과 같습니다.<br/>
                    a. “회원”이 관계법령 및 본 약관의 규정을 위반하여 “회사”로부터 강제탈퇴 처리가 되는 경우에는 본 조의 환불규정이 적용되지 않습니다.<br/>
                    b. 부정이용이 확인 된 구매 건에 대해서는 이유와 관계없이 환불이 불가능합니다.<br/>
                    c. “회사”가 “회원”에게 무료로 지급한 포인트나 쿠폰 등으로 인해 “회원”이 획득하게 된 금액에 대해서는 환불되지 않을 수 있습니다.<br/>
                    11. 본 조의 규정에도 불구하고 “회사”는 신뢰도 제고나 이벤트를 위해 일시적으로 환불 조건을 완화할 수 있습니다.<br/>
                </Description>
            </Content>
            <Footer />
        </Container>
    )
}

const Container = styled.div`
`

const Content = styled.div`
    padding-left: 32px;
    padding-right: 32px;
    padding-top: 140px;
    padding-bottom: 120px;
`

const Description = styled.div`
    white-space: pre-wrap;
`



export default Refund;